import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { SubmissionPublicationSearchProvider } from './context/submission-publication-search-context';
import { SubmissionPublicationSearchComponent } from './submission-publication-search-component';

export function SubmissionPublicationSearchFactory() {
    return (
        <BaseLayoutFactory>
            <SubmissionPublicationSearchProvider>
                <SubmissionPublicationSearchComponent />
            </SubmissionPublicationSearchProvider>
        </BaseLayoutFactory>
    );
}
